var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWifiHigh = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.125 19.125a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0m9.101-10.969a16.125 16.125 0 0 0-20.452 0 .75.75 0 0 0 .952 1.16 14.625 14.625 0 0 1 18.548 0 .75.75 0 0 0 .952-1.16M19.22 11.51a11.625 11.625 0 0 0-14.432 0 .75.75 0 1 0 .932 1.175 10.125 10.125 0 0 1 12.568 0 .75.75 0 1 0 .932-1.175m-3.025 3.352a7.13 7.13 0 0 0-8.383 0 .75.75 0 1 0 .883 1.213 5.625 5.625 0 0 1 6.617 0 .75.75 0 0 0 .883-1.213"
})));
export default SvgWifiHigh;